import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, createBlock as _createBlock, createTextVNode as _createTextVNode, resolveDynamicComponent as _resolveDynamicComponent } from "vue"
import _imports_0 from '../assets/main-logo-icon.png'
import _imports_1 from '../assets/main-logo.png'


const _hoisted_1 = {
  key: 0,
  src: _imports_0,
  height: "319",
  width: "319",
  alt: "raas-logo"
}
const _hoisted_2 = {
  key: 1,
  src: _imports_1,
  height: "319",
  width: "927",
  alt: "raas-logo",
  class: "logo"
}
const _hoisted_3 = {
  key: 0,
  class: "profile-name"
}
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { key: 0 }
const _hoisted_6 = { key: 0 }
const _hoisted_7 = { key: 0 }
const _hoisted_8 = { key: 0 }
const _hoisted_9 = { key: 0 }
const _hoisted_10 = { key: 0 }
const _hoisted_11 = { key: 0 }
const _hoisted_12 = { key: 0 }
const _hoisted_13 = { key: 0 }
const _hoisted_14 = { key: 0 }

import {
  Aim,
  DataAnalysis,
  Expand,
  Fold,
  MagicStick,
  Memo,
  OfficeBuilding,
  Operation,
  User,
  UserFilled,
  WarningFilled,
  Document,
} from "@element-plus/icons-vue";
import { useSelectOrganisation } from "@/stores/selectOrganisation";
import { onMounted } from "vue";
import { useNavigation } from "@/hooks/useNavigation";
import { useSession } from "@/stores/session";
import { useRefreshComponent } from "@/stores/refreshComponent";


export default /*@__PURE__*/_defineComponent({
  __name: 'NavigationBar',
  props: {
  isCollapsed: Boolean,
},
  emits: ["toggle-collapse"],
  setup(__props, { emit: __emit }) {

const { isSuperAdmin, isAdmin, user, initUser } = useSession();

const organisationStore = useSelectOrganisation();
const subOrganisation = organisationStore.currentOrganisation;
const organisation = organisationStore.currentTopOrganisation;
const { navigateTo } = useNavigation();
const { refreshNavigationBarKey } = useRefreshComponent();



// Emit for collapse toggling
const emit = __emit;

const goToProfile = () => {
  navigateTo(`/users/${user.value.id}`);
};

onMounted(async () => {
  await initUser();
});

return (_ctx: any,_cache: any) => {
  const _component_ElAvatar = _resolveComponent("ElAvatar")!
  const _component_ElDivider = _resolveComponent("ElDivider")!
  const _component_ElIcon = _resolveComponent("ElIcon")!
  const _component_ElMenuItem = _resolveComponent("ElMenuItem")!
  const _component_ElMenu = _resolveComponent("ElMenu")!

  return (_openBlock(), _createElementBlock("div", {
    key: _unref(refreshNavigationBarKey),
    class: "navbar"
  }, [
    _createElementVNode("div", {
      class: "logo-container",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(navigateTo)('/')))
    }, [
      (__props.isCollapsed)
        ? (_openBlock(), _createElementBlock("img", _hoisted_1))
        : (_openBlock(), _createElementBlock("img", _hoisted_2))
    ]),
    _createElementVNode("div", {
      class: "profile",
      onClick: goToProfile
    }, [
      _createVNode(_component_ElAvatar, {
        src: _unref(user).profile_picture,
        size: __props.isCollapsed ? 40 : 80,
        shape: "circle",
        icon: _unref(UserFilled)
      }, null, 8, ["src", "size", "icon"]),
      (!__props.isCollapsed)
        ? (_openBlock(), _createElementBlock("h2", _hoisted_3, _toDisplayString(_unref(user).first_name) + " " + _toDisplayString(_unref(user).last_name), 1))
        : _createCommentVNode("", true)
    ]),
    _createVNode(_component_ElDivider),
    _createVNode(_component_ElMenu, {
      "default-active": _ctx.$route.path,
      "background-color": "transparent",
      "text-color": "var(--quinary-color)",
      "active-text-color": "var(--secondary-color)",
      class: "custom-menu",
      router: ""
    }, {
      default: _withCtx(() => [
        _createVNode(_component_ElMenuItem, {
          class: "irma",
          index: "/irma"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_ElIcon, null, {
              default: _withCtx(() => [
                _createVNode(_unref(MagicStick))
              ]),
              _: 1
            }),
            (!__props.isCollapsed)
              ? (_openBlock(), _createElementBlock("span", _hoisted_4, "Irma"))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }),
        _createVNode(_component_ElMenuItem, {
          class: "irma-files",
          index: "/irma/files"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_ElIcon, null, {
              default: _withCtx(() => [
                _createVNode(_unref(Document))
              ]),
              _: 1
            }),
            (!__props.isCollapsed)
              ? (_openBlock(), _createElementBlock("span", _hoisted_5, "Bestanden"))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }),
        _createVNode(_component_ElDivider),
        (!_unref(isSuperAdmin))
          ? (_openBlock(), _createBlock(_component_ElMenuItem, {
              key: 0,
              index: `/organisations/${_unref(subOrganisation) || _unref(organisation)?.id}`
            }, {
              default: _withCtx(() => [
                _createVNode(_component_ElIcon, null, {
                  default: _withCtx(() => [
                    _createVNode(_unref(OfficeBuilding))
                  ]),
                  _: 1
                }),
                (!__props.isCollapsed)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_6, "Mijn Organisatie"))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }, 8, ["index"]))
          : _createCommentVNode("", true),
        _createVNode(_component_ElMenuItem, { index: "/contexts" }, {
          default: _withCtx(() => [
            _createVNode(_component_ElIcon, null, {
              default: _withCtx(() => [
                _createVNode(_unref(Aim))
              ]),
              _: 1
            }),
            (!__props.isCollapsed)
              ? (_openBlock(), _createElementBlock("span", _hoisted_7, "Context"))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }),
        _createVNode(_component_ElMenuItem, { index: "/risks" }, {
          default: _withCtx(() => [
            _createVNode(_component_ElIcon, null, {
              default: _withCtx(() => [
                _createVNode(_unref(WarningFilled))
              ]),
              _: 1
            }),
            (!__props.isCollapsed)
              ? (_openBlock(), _createElementBlock("span", _hoisted_8, "Risico's"))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }),
        _createVNode(_component_ElMenuItem, { index: "/measures" }, {
          default: _withCtx(() => [
            _createVNode(_component_ElIcon, null, {
              default: _withCtx(() => [
                _createVNode(_unref(Operation))
              ]),
              _: 1
            }),
            (!__props.isCollapsed)
              ? (_openBlock(), _createElementBlock("span", _hoisted_9, "Maatregelen"))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }),
        _createVNode(_component_ElMenuItem, { index: "/analyse" }, {
          default: _withCtx(() => [
            _createVNode(_component_ElIcon, null, {
              default: _withCtx(() => [
                _createVNode(_unref(DataAnalysis))
              ]),
              _: 1
            }),
            (!__props.isCollapsed)
              ? (_openBlock(), _createElementBlock("span", _hoisted_10, "Analyse"))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }),
        _createVNode(_component_ElMenuItem, { index: "/assessments" }, {
          default: _withCtx(() => [
            _createVNode(_component_ElIcon, null, {
              default: _withCtx(() => [
                _createVNode(_unref(Memo))
              ]),
              _: 1
            }),
            (!__props.isCollapsed)
              ? (_openBlock(), _createElementBlock("span", _hoisted_11, "Assessment"))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }),
        (_unref(isSuperAdmin) || _unref(isAdmin))
          ? (_openBlock(), _createBlock(_component_ElDivider, { key: 1 }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(__props.isCollapsed ? "" : "Admin"), 1)
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        (_unref(isSuperAdmin) || _unref(isAdmin))
          ? (_openBlock(), _createBlock(_component_ElMenuItem, {
              key: 2,
              index: '/organisations'
            }, {
              default: _withCtx(() => [
                _createVNode(_component_ElIcon, null, {
                  default: _withCtx(() => [
                    _createVNode(_unref(OfficeBuilding))
                  ]),
                  _: 1
                }),
                (!__props.isCollapsed)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_12, "Organisaties"))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        (_unref(isSuperAdmin) || _unref(isAdmin))
          ? (_openBlock(), _createBlock(_component_ElMenuItem, {
              key: 3,
              index: "/users"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_ElIcon, null, {
                  default: _withCtx(() => [
                    _createVNode(_unref(User))
                  ]),
                  _: 1
                }),
                (!__props.isCollapsed)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_13, "Gebruikers"))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        (_unref(isSuperAdmin))
          ? (_openBlock(), _createBlock(_component_ElMenuItem, {
              key: 4,
              index: "/branches"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_ElIcon, null, {
                  default: _withCtx(() => [
                    _createVNode(_unref(Memo))
                  ]),
                  _: 1
                }),
                (!__props.isCollapsed)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_14, "Branches"))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        _createVNode(_component_ElDivider)
      ]),
      _: 1
    }, 8, ["default-active"]),
    _createElementVNode("div", {
      class: "collapse-button",
      onClick: _cache[1] || (_cache[1] = ($event: any) => (emit('toggle-collapse')))
    }, [
      _createVNode(_component_ElIcon, null, {
        default: _withCtx(() => [
          (_openBlock(), _createBlock(_resolveDynamicComponent(__props.isCollapsed ? _unref(Expand) : _unref(Fold))))
        ]),
        _: 1
      })
    ])
  ]))
}
}

})